import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FocusHelperService {

  /**
   * Automatically focuses an element inside a container.
   * Priority: custom selector → [autofocus] → first focusable element
   */
  autoFocus(container: HTMLElement, customSelector?: string) {
    requestAnimationFrame(() => {
      let element: HTMLElement | null = null;
  
      // 1. Try custom selector
      if (customSelector) {
        element = container.querySelector(customSelector) as HTMLElement;
      }
  
      // 2. Try [autofocus]
      if (!element) {
        element = container.querySelector('[autofocus]') as HTMLElement;
      }
  
      // 3. Fallback to first focusable
      if (!element) {
        element = this.findFirstFocusable(container);
      }
  
      // 4. Focus or blur
      if (element) {
        element.focus();
      } else {
        const active = document.activeElement as HTMLElement;
        if (active && active !== document.body) {
          active.blur(); // 👈 blur if nothing else to focus
          console.warn('FocusHelperService: No focusable element found — active element blurred.');
        }
      }
    });
  }
  

  /**
   * Finds the first focusable element inside a container.
   */
  private findFirstFocusable(container: HTMLElement): HTMLElement | null {
    const selectors = [
      'button:not([disabled])',
      '[href]',
      'input:not([disabled]):not([type=hidden])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ];
    const elements = container.querySelectorAll<HTMLElement>(selectors.join(','));
    return elements.length > 0 ? elements[0] : null;
  }
}
